import styled from 'styled-components/macro'

const AppMain = styled.main`
  flex-grow: 1;
`

export default AppMain
